
import React, { useState, useEffect, Component, useRef } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { testPdf } from './../Utilities/WSUtil';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`



class PdfDocument extends Component {

    constructor(props) {
        super(props);
        this.loadSuccess = this.loadSuccess.bind(this);
        this.state = {
            pages: 1,
            loadFinished: false
        };
    }


    loadSuccess(pages) {
        this.setState({ pages: pages.numPages, loadFinished: true });
    }


    render() {
        if (this.props.pdfData) {
            return (
                <Document file={this.props.pdfData} className="pdf-document"
                    onLoadSuccess={this.loadSuccess}>
                    {
                        Array.from(new Array(this.state.pages),(el, index) => <Page pageNumber={index + 1} renderTextLayer={false} renderAnnotationLayer={false} scale={1.38} className="pdf-page" />)
                    }
                    {/* <Page pageNumber={1} renderTextLayer={false} renderAnnotationLayer={false} scale={1.38} className="pdf-page" /> */}
                    {/* <Page pageNumber={2} renderTextLayer={false} renderAnnotationLayer={false} scale={1.38} className="pdf-page" /> */}

                </Document>

            );
        }
        else return null;
    }
}

export default PdfDocument;